import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import acc from 'accounting'

export default class KartyMiesieczneTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    renderMiesiacRok(cell, row) {
        return (<div>
            <div>{row.rok + ', ' + cell}</div>
            <div style={{color:'grey',fontSize:'12px',fontStyle:'italic'}}>{row.waznyOd+' - '+row.waznyDo}</div>
        </div>)
    }

    formatOdcinek(cell,row){
        if(Boolean(row.dwiestrony)){
            // obustronny
            return(<div>
                <div>{row.nazMiOd} <i className={'fa fa-long-arrow-right'}></i> {row.nazMiDo}</div>
                <div>{row.nazMiDo} <i className={'fa fa-long-arrow-right'}></i> {row.nazMiOd}</div>
            </div>)

        }
        else{
            // jednostronny
            return <div>{row.nazMiOd} <i className={'fa fa-long-arrow-right'}></i> {row.nazMiDo}</div>
        }
    }

    formatCena(cell,row){
        if(Boolean(row.dwiestrony)){
            // obustronny, suma dwóch cen skladowych
            return acc.formatMoney(row.calacena)
        }
        else{
            // jednostronny
            return acc.formatMoney(row.cena)
        }
    }

    formatStatus(cell,row){
        if(row.status === null) return '?'
        if(cell == -2){
            return <div><i className={'fa fa-refresh'} style={{color:'grey'}}></i> zwrócony</div>
        }
        else if(cell == 1){
            return <div><i className={'fa fa-check'} style={{color:'forestgreen'}}></i> opłacony</div>
        }
        else{
            return <div><i className={'fa fa-times'} style={{color:'firebrick'}}></i> do opłaty</div>
        }
    }

    render() {

        return (
            <div>
                <BootstrapTable data={this.props.miesieczneNaKarcie}
                                hover
                >
                    <TableHeaderColumn dataField='idBm' isKey thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >ID biletu</TableHeaderColumn>
                    <TableHeaderColumn dataField='miesiacSlownie'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderMiesiacRok}
                    >Ważny</TableHeaderColumn>
                    <TableHeaderColumn dataField='miejscowosciBilet'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.formatOdcinek}
                    >Odcinek</TableHeaderColumn>
                    <TableHeaderColumn dataField='cena'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.formatCena}
                    >Cena</TableHeaderColumn>
                    <TableHeaderColumn dataField='status'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.formatStatus}
                    >Status</TableHeaderColumn>
                    <TableHeaderColumn dataField='platnosciInfo'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={(cell, row) => {
                                           if (Boolean(row.platnoscTpay)) {
                                               return row.platnosciTransakcja + ' ' + row.platnoscTpay
                                           }
                                           else {
                                               return row.platnosciTransakcja
                                           }
                                       }}
                    >Płatności</TableHeaderColumn>
                    <TableHeaderColumn dataField='uwagi'
                                       thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                       dataFormat={(cell, row) => {
                                           if (Boolean(cell)) {
                                               return <div style={{fontSize:'12px',lineHeight:'1.1em'}}>{cell}</div>
                                           }
                                       }}
                    >Uwagi</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/karty/components/KartyMiesieczneTable.js